<template>
	<div class="flex flex-col h-full">
		<main class="relative flex-grow">
			<router-view />
		</main>
	</div>
</template>
